import vue from 'vue'
import Vuex from 'vuex'
vue.use(Vuex)
const state = {
	sessionInfo: null,
	loginFlag: false,
	roleId: null,
	authcode: null
}

const mutations = {
	setSessionInfo(state, isInfo) {
		state.sessionInfo = isInfo
	},
	setLoginFlag(state, isLogin) {
		state.loginFlag = isLogin
	},
	setRole(state, isRole) {
		state.roleId = isRole
	},
	setAuthcode(state, isAuth) {
		state.authcode = isAuth
	}
}

export default new Vuex.Store({
	state,
	mutations
})